import TextBase from '../text';
import { Colors } from '../../themes/Colors';

import AddCircleIcon from '../../assets/image/png/add.png';
import { translate } from '../../helper';

export const AddPaymentMethodButton = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      style={{
        width: '100%',
        padding: 'calc(var(--sp-md2)*1.32075) calc(var(--sp-md2)*1.69811)',
        borderRadius: 'calc(var(--sp-md2)*1.32075)',
        border: '1px solid #E5E7EB',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'column',
        cursor: 'pointer',
        marginTop: 'calc(var(--sp-md2)*1.132075)',
        background: 'linear-gradient(135deg, #FFFFFF, #F7F7F7)'
      }}
    >
      <img
        src={AddCircleIcon}
        style={{ height: 'calc(var(--sp-md2)*3.7735)', width: 'calc(var(--sp-md2)*3.7735)', marginBottom: 'calc(var(--sp-md2)*1.509433)' }}
      />

      <TextBase
        style={{ textAlign: 'center' }}
        fontWeight={600}
        size={'var(--fs-md2)'}
        color={Colors.black}
      >
       {translate("addPaymentMethod")}
      </TextBase>
    </div>
  );
};
